import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup } from '@angular/forms';
import { I18n, CustomDatepickerI18n } from '../datepicker-ita/datepicker-ita.component';

/**
 * Variante "form" del datepicker pill, usata nei modali del ristorante
 * (aggiungi / modifica / disponibilità). Lavora con un FormGroup esterno che
 * contiene un control "data" (required) e mostra il messaggio di validazione.
 *
 * Esempio:
 *   <sb-datepicker-form [group]="globalData.ristoranteAddForm"
 *                       [(date)]="globalData.dataAddRistorante">
 */
@Component({
  selector: 'sb-datepicker-form',
  templateUrl: './sb-datepicker-form.component.html',
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
  standalone: false
})
export class SbDatepickerFormComponent {
  /** FormGroup esterno con un control "data" (Validators.required) */
  @Input() group!: UntypedFormGroup;

  /** Valore data legato (two-way [(date)]) — guida il valore usato dal Salva del genitore */
  @Input() date: NgbDateStruct;
  @Output() dateChange = new EventEmitter<NgbDateStruct>();

  /** Se true mostra l'errore solo dopo che il campo è stato toccato (add/disp); edit usa false */
  @Input() guardTouched = true;
}
